// extracted by mini-css-extract-plugin
export default {"menu":"Tnas_menu__1XoBv","nav":"Tnas_nav__ItuEe"};